import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function WordCloudDisplay({ memorialId }) {
  const [words, setWords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWordCloud();
  }, [memorialId]);

  const fetchWordCloud = async () => {
    try {
      const response = await axios.get(`${API}/memorial/${memorialId}/wordcloud`);
      setWords(response.data);
    } catch (error) {
      console.error('Error fetching word cloud:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (words.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-foreground-muted">
        <p className="text-base font-sans">Not enough messages to generate word cloud yet</p>
      </div>
    );
  }

  // Get max value for scaling
  const maxValue = Math.max(...words.map(w => w.value));
  const minValue = Math.min(...words.map(w => w.value));
  
  // Function to calculate font size
  const getFontSize = (value) => {
    const minSize = 16;
    const maxSize = 48;
    const normalized = (value - minValue) / (maxValue - minValue);
    return minSize + normalized * (maxSize - minSize);
  };

  const colors = ['#556B2F', '#D2691E', '#4F7942', '#A0522D', '#425424'];

  return (
    <div 
      className="flex flex-wrap items-center justify-center gap-4 p-6 bg-paper rounded-lg" 
      style={{ minHeight: '300px' }}
      data-testid="wordcloud-display"
    >
      {words.slice(0, 50).map((word, index) => (
        <span
          key={index}
          className="font-serif transition-all hover:scale-110 cursor-pointer"
          style={{
            fontSize: `${getFontSize(word.value)}px`,
            color: colors[index % colors.length],
            lineHeight: 1.2
          }}
          title={`${word.text} (${word.value} times)`}
        >
          {word.text}
        </span>
      ))}
    </div>
  );
}
